import axios from "@/api/config";

const videoCourse = {
  getVideoCourseById(data) {
    return axios.get(
      `${process.env.BASE_URL}/videoCourse/getVideoCourse/` + data,
      {}
    );
  },
  getVideoCourse(data) {
    return axios.get(`${process.env.BASE_URL}/videoCourse/getVideoCourse`, {
      params: data
    });
  },
  getVideoCourseList(data) {
    return axios.get(`${process.env.BASE_URL}/videoCourse/getVideoCourseList`, {
      params: data
    });
  },
  getVideoCourseTree(data) {
    return axios.get(`${process.env.BASE_URL}/videoCourse/getVideoCourseTree`, {
      params: data
    });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/videoCourse/pageList`, data);
  },
  addVideoCourse(data) {
    return axios.post(
      `${process.env.BASE_URL}/videoCourse/addVideoCourse`,
      data
    );
  },
  updateVideoCourse(data) {
    return axios.put(
      `${process.env.BASE_URL}/videoCourse/updateVideoCourse`,
      data
    );
  },
  copyVideoCourse(data) {
    return axios.post(
      `${process.env.BASE_URL}/videoCourse/copyVideoCourse`,
      data
    );
  },
  deleteVideoCourse(data) {
    return axios.delete(
      `${process.env.BASE_URL}/videoCourse/deleteVideoCourse`,
      { data: data }
    );
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/videoCourse/exportExcel`, {
      params: data
    });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/videoCourse/importData`, data);
  },
  updateVideoCourseEnable(data) {
    return axios.post(
      `${process.env.BASE_URL}/videoCourse/updateVideoCourseEnable`,
      data
    );
  },
  bindTencentVideoType(data) {
    return axios.post(
      `${process.env.BASE_URL}/videoCourse/bindTencentVideoType`,
      data
    );
  }
};

export default videoCourse;



// WEBPACK FOOTER //
// ./src/api/videoCourse.js